export default __webpack_public_path__ + "static/media/tensorflow.b675fae9.svg";